import { RouteObject } from 'react-router-dom'
import { VendorListPage } from './pages/VendorListPage'

/**
 * Reference module routing. Copy this file's shape for every new module:
 *   modules/<name>/routes.tsx  ->  contributes a RouteObject[] to the central router.
 * Mirrors the Vue app's per-module router.js.
 */
export const purchaseRoutes: RouteObject[] = [
  { path: 'purchase', element: <VendorListPage /> },
  // { path: 'purchase/vendors/new', element: <AddVendorPage /> },
]
